import React, { useState, useEffect } from 'react';
import { getTodos, updateTodo } from '../../../utils/FamilyApiService';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './DragDropWeeklyTasks.css';

const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};

const grid = 3;

const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    background: isDragging ? 'lightgreen' : 'white',
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: 'large',
    color: 'black',
    boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.5)',
    ...draggableStyle
});

const getListStyle = (isDraggingOver, droppableId) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
    width: '50%',
    marginRight: droppableId === 'todos' ? '10px' : '0px',
    marginLeft: droppableId === 'completed' ? '10px' : '0px',
    borderRadius: '10px',
    position: 'relative',
    padding: '10px 10px 10px 10px'
});

const DragDropWeeklyTasks = ({
    familyMemberName
}) => {

    const [loading, setLoading] = useState(true);
    const [todos, setTodos] = useState([]);
    const [completed, setCompleted] = useState([]);

    useEffect(() => {
        async function getTodosLocal() {
            let todoList = [];
            let completedList = [];
            var response = await getTodos(familyMemberName, 0)
            response.forEach(element => {
                element.dndId = element.id + 'item';
                if (element.completed) { completedList.push(element); }
                else { todoList.push(element); }
            });
            setTodos(todoList);
            setCompleted(completedList);
            setLoading(false);
        }

        getTodosLocal();
    }, [familyMemberName]);

    function getList(droppableId) {
        if (droppableId === 'todos') return todos;
        return completed;
    }

    function onDragEnd({ source, destination }) {
        if (!destination) {
            return;
        }

        if (source.droppableId !== destination.droppableId) {
            var sourceList = getList(source.droppableId);
            const result = move(
                sourceList,
                getList(destination.droppableId),
                source,
                destination
            );
            var movedItem = sourceList[source.index];
            movedItem.completed = destination.droppableId === 'completed';
            setTodos(result.todos);
            setCompleted(result.completed);
            updateTodo(movedItem);
        }
    };

    if (loading) {
        return (
            <div className="loader"></div>
        );
    }
    else {

        return (
            <div className="dndContainer">
                <img className="dndDroppableImage1" src="/images/todo.png" />
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="todos">
                        {(provided, snapshot) => (
                            <div className="innerTodo"  
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver, 'todos')}>
                                {todos.map((item, index) => (
                                    <Draggable
                                        key={item.dndId}
                                        draggableId={item.dndId}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}><span className="taskIcon todoIcon"><i className="fas fa-broom"></i></span>
                                                {item.description}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                    <img className="dndDroppableImage2" src="/images/done.png" />
                    <Droppable droppableId="completed">
                        {(provided, snapshot) => (
                            <div className="innerTodo" 
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver, 'completed')}>
                                {completed.map((item, index) => (
                                    <Draggable
                                        key={item.dndId}
                                        draggableId={item.dndId}
                                        index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                )}><span className="taskIcon completedIcon"><i className="fas fa-smile"></i></span>
                                                {item.description}
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        );
    }
}

export default DragDropWeeklyTasks;